module.exports = __webpack_public_path__ + "static/media/CSA.73998b01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CSA.svg
// module id = 232
// module chunks = 0